// based on https://github.com/ksheedlo/isomorphic-base64 to use in client and server envs interchangeably.
// due to lack of types, reimplemented and maintained here.
import { Buffer } from 'buffer';

export function atob(val: string) {
	return Buffer.from(val, 'base64').toString();
}

export function btoa(val: WithImplicitCoercion<string | Uint8Array<ArrayBufferLike> | readonly number[]>) {
	return Buffer.from(val).toString('base64');
}

/**
 * use this to make a Base64 encoded string URL friendly,
 * i.e. '+' and '/' are replaced with '-' and '_' also any trailing '='
 * characters are removed
 * source: https://jsfiddle.net/magikMaker/7bjaT
 * @param str the encoded string
 * @returns the URL friendly encoded String
 */
export function base64EncodeUrl(str: string) {
	return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
}
